import { render, staticRenderFns } from "./IframeEdit.vue?vue&type=template&id=65a2ad20"
import script from "./IframeEdit.vue?vue&type=script&lang=js"
export * from "./IframeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports